let hashObj;
$(document).ready(function() {

    hashObj = generateObjectFromHash(window.location.hash);
    // let lang = setLanguage();
    // auf der globalen Suche auch den Suchbegriff ausgeben
    displaySearchValue(hashObj);

    // Buchenbox v2
    $.each($('.buchenFilter.v2'), function(k, v) {
        initbFv2($(this));
    });

    // Pauschenfilter v2
    $.each($('.pauschalenFilter.v2'), function(k, v) {
        initPauschalenv2($(this));
    });

    //NothingFound Filter zurücksetzen aka Seite ohne Hash laden
    $('#td').on('click', '.nothingFound .resetBtn, .reset-holder .resetBtn', function() {
        window.location = window.location.pathname;
    });

    $('#td').on('click', 'a.image span.map-indicator', function(e) {
        e.preventDefault();
        $(this).siblings('.ttg-list-entry-map').toggleClass('show-map');
    });

    // Init Functions (LIST)
    if ($('#td').length) {

        if ($(window).width() < breakpointMedium) {
            $('#td').addClass('mobileMode');
            $('#td #sortIndicator>span').text($('#td #sorting option:selected').text());
        } else {
            $('#td').removeClass('mobileMode');
        }

        if ($('#listOptions #sorting').length) { // mach "Dinge" mit dem Sort Parameter, aber nur wenn das Dropdown vorhanden ist
            if (getHashParameter('sort').length > 0) {
                setTimeout(function() {
                    $('#listOptions #sorting option[value="' + getHashParameter('sort') + '"]').prop('selected', true);
                }, 50);
            } else {
                hashObj.sort = $('#listOptions #sorting').val();
            }
            if (!navigator.geolocation) {
                $('#listOptions #sorting option[value="distance+asc"]').prop('disabled', true);
            }
            if ($('body').hasClass('ttg-tdTermianl') && $('#td').data('latlon') && $('#td').data('latlon').length > 0) {
                $('#listOptions #sorting option[value="distance+asc"]').prop('disabled', false);
            }
        }

        if (getHashParameter('latitude').length > 0 && getHashParameter('longitude').length > 0) {
            $('#td').attr('data-latlon', getHashParameter('latitude') + ',' + getHashParameter('longitude'));
        } else if ($('body').hasClass('ttg-tdTerminal') && getHashParameter('latlon').length > 0) {
            $('#td').attr('data-latlon', getHashParameter('latlon'));
        }

        if ($('body').hasClass('ttg-tdTerminal') && $('#td').data('latlon') && $('#td').data('latlon').length > 0) {

            // im Terminal sind die Koordinaten fix hinterlegt > Navigator muss/darf/soll nicht kontaktiert werden
            hashObj.latitude = $('#td').data('latlon').split(',')[0];
            hashObj.longitude = $('#td').data('latlon').split(',')[1];
            getMetaResult($('#td'), hashObj, true, true);

        } else if ($('#tdAppBaseUrl').data('lat') && $('#tdAppBaseUrl').data('lon')) {

            // im Webstream können die Koordinaten fix hinterlegt werden
            hashObj.latitude = $('#tdAppBaseUrl').data('lat');
            hashObj.longitude = $('#tdAppBaseUrl').data('lon');
            getMetaResult($('#td'), hashObj, true, true);

        } else if (hashObj.sort === 'distance+asc' && (!hashObj.latitude || !hashObj.longitude) && navigator.geolocation) {

            navigator.geolocation.getCurrentPosition(
                function(position) {

                    hashObj.latitude = position.coords.latitude;
                    hashObj.longitude = position.coords.longitude;
                    $('#td').attr('data-latlon', hashObj.latitude + ',' + hashObj.longitude);
                    getMetaResult($('#td'), hashObj, false, true);

                },
                function(error) {

                    // Wenn GeoLocation nicht vorhanden lade Liste mit Standardsortierung title+asc & update Hash
                    geoLocationErrorOutput(error);
                    hashObj.sort = "title+asc";
                    $('#listOptions #sorting option[value="' + hashObj.sort + '"]').prop('selected', true);
                    getMetaResult($('#td'), hashObj, true, true);

                }
            );

        } else {

            getMetaResult($('#td'), hashObj, false, true);

        }

        if ($('#filterFacetten').length) {
            labelManager();
        }

        $('#listOptions #sorting').change(function(e) {
            generateHashAndGetResult(e, $(this));
        });

        $('#listOptions button:not(#triggerFilter)').click(function(e) {
            e.preventDefault();
            if ($(this).hasClass('ttgKarteTab')) {
                // openMapsModal();
                // _ttgMaps.f.showInlineListMap();
                console.log('via _TTGMaps.js');
            } else {
                $(this).closest('.option').find('.active').removeClass('active');
                $(this).addClass('active');
                $('#td #resultSet').empty();
                if ($(this).hasClass('ttgKachelnTab')) {
                    $('#td').addClass('layout-kacheln').removeClass('layout-liste');
                } else {
                    $('#td').removeClass('layout-kacheln').addClass('layout-liste');
                }
                generateHashAndGetResult(e, $(this));
            }
        });

        $('#td.mobileMode').on('click', '.wrapper button#triggerFilter, #filterFacetten .closeFilter, #filterFacetten .headline', function(e) {
            e.preventDefault();
            $('#filterFacetten').toggleClass('show');
            if ($('#filterFacetten').hasClass('show')) {
                $('#filterFacetten').attr('role', 'dialog').attr('aria-modal', 'true');
                openDialog("filterFacetten", $(this));
            } else {
                $('#filterFacetten').removeAttr('role', 'dialog').removeAttr('aria-modal', 'true');
                aria.getCurrentDialog().close();
            }
        });

        $('#filterFacetten')
            .on('click', '.form-check', checkFacet)
            .on('keydown', '.form-check', function(e) {
                var code = e.which;
                // 13 = Return, 32 = Space
                if ((code === 13) || (code === 32)) {
                    // console.log("Test");
                    $(this).click();
                }
            })
            .on('click', '#searchStringFilter .btn, .numberFilter .btn', function(e) {
                e.preventDefault();
                trackEvent($('#fixedFilter').data('eventcatforjs'), 'Suchbegriff', $('#searchString').val());
                generateHashAndGetResult(e, $(this));
            })
            .on('keyup', '.qText', function(e) {
                if (e.keyCode === 13) { // Auf Enter Suche auslösen
                    trackEvent($('#fixedFilter').data('eventcatforjs'), 'Suchbegriff', $(this).val());
                    generateHashAndGetResult(e, $(this));
                }
            })
            .on('change', 'select.form-control', function(e) {
                generateHashAndGetResult(e, $(this));
            });

        window.onpopstate = function(event) {
            // console.log('popstate');
            // console.log(event.state);
            if (event.state) {
                getMetaResult($('#td'), event.state, false, true);
            }
        };

        if ('#td.veranstaltung') {
            $('#td.veranstaltung .layout-kacheln-triggerFilter').click(function(e) {
                e.preventDefault();
                var closeText = $(this).data('closetext');
                $(this).toggleClass('active');
                if ($(this).hasClass('active')) {
                    // console.log($(this));
                    $('#td.veranstaltung .col-filter').addClass('show');
                    $(this).prepend('<span class="close-filter fa-regular fa-xmark fa-fw"></span><span class="close-filter">' + closeText + '</span>');
                    $('#resultSet').addClass('kachel-filter-mode');
                    $('#td').addClass('kachelFilterModeOn');
                } else {
                    $('#td.veranstaltung .col-filter').removeClass('show');
                    $(this).find('span.close-filter').remove();
                    $('#resultSet').removeClass('kachel-filter-mode');
                    $('#td').removeClass('kachelFilterModeOn');
                }
            });
        }

    }

    $('body').on('keydown', '#filterFacetten', function(e) {
        var code = e.which;
        // 27 = ESC
        if ((code === 27)) {
            $('#filterFacetten .closeFilter').click();
        }
    });

    // Click Suchen Btn BuchenFilter
    $('body').on('click', '.buchenFilter.v2 .buchenbox_button button', function(e) {
        generateHashAndGetResult(e, $(this));
        if ($(this).hasClass('initialized')) {
            trackEvent('Unterkunftssuche Buchenbox', 'Suchen Button', $(this).closest('.buchenFilter.v2').data('mode'));
        }
        $(this).addClass('initialized');
    });

    // Click Suchen Btn Erlebnis Buchenbox
    $('body').on('click', '.pauschalenFilter.v2 .pauschalen-box-btn button', function(e) {
        generateHashAndGetResult(e, $(this));
        if ($(this).hasClass('initialized')) {
            trackEvent('Erlebnis Buchenbox', 'Suchen Button', $(this).closest('pauschalenFilter.v2').data('mode'));
        }
        $(this).addClass('initialized');
    });

    // Init Functions (DETAIL)
    $('.buchenFilter.v2.mode-detail').find('.buchenbox_button button').trigger('click');

    // $('#td').on('click', '.dynamicAufAnfrageLink', function(e) {
    //     e.preventDefault();
    //     $('#listOptions .active').removeClass('active');
    //     $('#listOptions .aufAnfrageTab').addClass('active');
    //     generateHashAndGetResult(e, $(this));
    // });

    // if ($('.buchenFilter.v2.mode-list').length || $('.buchenFilter.v2.mode-detail').length) {
    //     $('.ttgQuickNavi.buchenFilterV2 .ttgUKQuickNaviHeading').remove();
    // } else {
    //     if ($('.ttgQuickNavi.buchenFilterV2').hasClass('isMetaSuche_1')) {
    //         $('.ttgQuickNavi.buchenFilterV2 .ttgUKQuickNaviHeading').addClass('show').click(function(e) {
    //             ajaxBuchenFilter('ajaxBuchenFilter');
    //         });
    //         if ($('#ajaxBuchenFilterHolder.showInitialy').length && $(window).width() > 991) {
    //             ajaxBuchenFilter('ajaxBuchenFilter'); 
    //         }
    //     }
    // }
    if ($('.buchenFilter.v2.mode-list').length || $('.buchenFilter.v2.mode-detail').length || $('#tosc5target').length) {
        $('#bookingStrip').remove();
    }

    if ($('#bookingStrip').length) {
        ajaxBuchenFilter('ajaxBuchenFilter');
    }

    if ($('#tosc5target').length) {
        $('#mobileBottomTrigger').addClass('buchenBtn_0').removeClass('buchenBtn_1');
    }

});

const handleDate = function(dateTmp, interval) {
    let dateObj = dateTmp.split(".");
    dateObj = new Date(dateObj[2], (dateObj[1] - 1), dateObj[0], '00', '00', '00');
    // um interval raufzählen, zb. 1 Tag
    dateObj.setDate(dateObj.getDate() + interval);
    return dateObj;
};

const getURLParameter = function(name) {
    const value = decodeURIComponent((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [true, ""])[1]);
    return (value !== 'null') ? value : false;
};

const getHashParameter = function(name) {
    const value = decodeURIComponent((RegExp(name + '=' + '(.+?)(&|$)').exec(location.hash) || [true, ""])[1]);
    return (value !== 'null') ? value : false;
};

const generateObjectFromHash = function(givenHash) {
    let hashObj = {};
    if (givenHash) {
        const hash = givenHash.replace('#', '');
        const hashArr = hash.split("&");
        $.each(hashArr, function(k, v) {
            const paramArr = v.split("=");
            hashObj[paramArr[0]] = decodeURI(paramArr[1]);
        });
    }
    if ($(window).width() < 992 && hashObj.layout) {
        hashObj.layout = 'liste';
    }

    // wenn startdate und enddate via HASH-URL übergeben werden soll die eigentlich leere Buchenbox befüllt werden
    if (hashObj.startdate && hashObj.enddate) {
        $td.find('.buchenFilter.v2').removeClass('emptyInitialBuchenBox-1');
    }

    return hashObj;
};

const generateHashFromObject = function(givenObj) {

    let newHash = "";
    let i = 0;
    $.each(givenObj, function(k, v) {
        newHash += (i > 0) ? "&" : "#";
        newHash += k + "=" + v;
        i++;
    });
    return (newHash === "") ? "#" : newHash;
};

const generateNewHashObject = function(updateObj) {
    const oldHashString = window.location.hash;
    const oldHashObj = generateObjectFromHash(oldHashString);
    let newHashObj = oldHashObj;
    $.each(updateObj, function(k, v) {

        if (k === 'offset' && parseInt(v) === 0) {
            delete newHashObj.offset; // entferne Parameter "offset" wenn 0
        } else {
            newHashObj[k] = v;
        }

    });
    return newHashObj;
};

const getMetaResult = function($td, params, updateState, loadFacets) {

    if ($td.data('print') == 1) {
        loadFacets = false;
        $('body').addClass('tdListPrint');

        // PrintHeader
        const $logo = $('<div />').addClass('col-6 text-right').append($('header a.logo svg'));
        const $footerObj = $('footer .container div.col-12.col-md-4.col-lg-4.col-xl-3 .navigation');
        const adresse = '<b>' + $footerObj.find('div').eq(2).text() + '</b><br>' + $footerObj.find('div').eq(3).text() + ', ' + $footerObj.find('div').eq(4).text();
        const kontakt = $footerObj.find('div').eq(0).html() + ', ' + $footerObj.find('div').eq(1).html();
        // const email = $('footer .ttgFooterKontaktButtons .email').html();
        let $printHeader = $('<div />').prop('id', 'printHeader').addClass('row');
        $printHeader.append($('<div />').addClass('col-6').html(adresse + '<br>' + kontakt));
        $printHeader.append($logo);
        $printHeader.prependTo('main');
    }

    // wenn $_GET['no_cache']=1 gesetzt ist, soll es metaResult Action übergeben werden, damit das Plugin-Caching deaktiviert werden kann
    const urlQueryString = window.location.search;
    const urlParams = new URLSearchParams(urlQueryString);
    let noCache = 0;
    if (urlParams.get('no_cache')) {
        noCache = 1;
    }

    const mobileMode = $('#td.mobileMode').length;
    let response = (parseInt($td.find('#resultSet').data('type')) === 1765 || parseInt($td.find('#resultSet').data('type')) === 1830) ? 'meta-hypersearch' : 'meta';
    let lang = $td.data('lang');
    let sysLanguageUid = $td.data('syslanguageuid');
    // tosc 5 tosc5DetailPid wird für den Webstream benötigt
    let tosc5 = 0;
    let tosc5DetailPid = 0;
    if ($('.buchenFilter.v2, .pauschalenFilter.v2').data('tosc5')) {
        tosc5 = parseInt($('.buchenFilter.v2, .pauschalenFilter.v2').data('tosc5'));
    }
    if ($('.buchenFilter.v2, .pauschalenFilter.v2').data('tosc5detailpid')) {
        tosc5DetailPid = parseInt($('.buchenFilter.v2, .pauschalenFilter.v2').data('tosc5detailpid'));
    }
    if (lang == "cz") {
        lang = "cs";
    }

    // appBaseUrl wird für die Streaming App benötigt
    let appBaseUrl = ($('#tdAppBaseUrl').data('appbaseurl')) ? $('#tdAppBaseUrl').data('appbaseurl') : '';

    let emptyInitialBuchenBox = "";
    if ($td.find('.buchenFilter.v2').hasClass('emptyInitialBuchenBox-1')) {
        emptyInitialBuchenBox = ($td.find('.buchenFilter.v2').hasClass('emptyInitialBuchenBox-1')) ? '&emptyInitialBuchenBox=1' : '';
    }

    if ($('#td.veranstaltung').data('unrollintervals') === 1 && params.sort === 'interval_first_match+asc,title+asc') {
        // if ($('#td.veranstaltung.layout-kacheln').data('unrollintervals') === 1 && params.sort === 'interval_first_match+asc,title+asc') { // Version wenn unrollintervals nur bei Kacheln sein soll
        params.sort = 'start+asc';
    }

    // Tannheimertal Special
    if ($td.data('print') == 1) {
        if ($td.find('.buchenFilter.v2').hasClass('emptyInitialBuchenBox-1')) {
            params.startdate = '';
            params.enddate = '';
            params.occupation = '';
            params.filterstate = 'all';
        }
    }

    console.log('### getMetaResult ###');
    console.log(params);

    $.ajax({
        method: 'POST',
        url: appBaseUrl + "/index.php?id=" + rootPage + "&L=" + sysLanguageUid + "&response=" + response + "-resultset&tdType=" + $td.data('type') + "&type=" + $td.find('#resultSet').data('type') + emptyInitialBuchenBox,
        // GET params only for identification in devTools
        data: {
            type: $td.find('#resultSet').data('type'),
            // t3 typeNum
            response: response,
            tdType: $td.data('type'),
            pageId: $td.data('pageid'),
            pluginUid: $td.data('pluginuid'),
            params: params,
            settings: $td.data('settings'),
            metaConfig: $td.data('metaconfig'),
            metaFeratelLogo: $td.data('metaferatellogo'),
            metaCustomLogo: $td.data('metacustomlogo'),
            webstream: $td.data('webstream'),
            layout: ($td.hasClass('layout-kacheln') && $(window).width() >= 992) ? 'kacheln' : 'liste',
            lang: lang,
            sysLanguageUid: sysLanguageUid,
            feratelTosc5: tosc5,
            feratelTosc5DetailPid: tosc5DetailPid,
            noCache: noCache,
            cachetime: $td.data('cachetime'),
            print: $td.data('print')
        },
        beforeSend: function(xhr, o) {

            _ttgMaps.f.listMap.resetListMap();
            // $td.find('#listOptions .optionKarte').addClass('loading');
            $td.addClass('loading');

            if ($(window).width() < 1169) {
                $td.removeClass('layout-kacheln').addClass('layout-liste');
                $td.find('#listOptions .optionStyle button.active').removeClass('active');
                $td.find('#listOptions .optionStyle button.ttgListeTab').addClass('active');
            } else if (params.layout) {
                $td.removeClass('layout-kacheln').removeClass('layout-liste').addClass('layout-' + params.layout);
                $td.find('#listOptions .optionStyle button.active').removeClass('active');
                if (params.layout === 'liste') {
                    $td.find('#listOptions .optionStyle button.ttgListeTab').addClass('active');
                } else {
                    $td.find('#listOptions .optionStyle button.ttgKachelnTab').addClass('active');
                }
            }

            if ('#td.veranstaltung') {
                $('#td.veranstaltung .col-filter').removeClass('show');
                $('#td.veranstaltung .layout-kacheln-triggerFilter').removeClass('active').find('span.close-filter').remove();
                $('#resultSet').removeClass('kachel-filter-mode');
                $('#td').removeClass('kachelFilterModeOn');
            }

            //console.log('BEFORE');
            //console.log(o);
            //console.log(xhr);
            if ($('#td #filterFacetten .invalid').length) {
                $('#td #filterFacetten').addClass('invalidIndicator');
                document.getElementById("filterFacetten").scrollIntoView();
                return false;
            }
            if (!loadFacets) {
                if (mobileMode) {
                    document.getElementById("resultSet").scrollIntoView();
                } else {
                    document.getElementById("td").scrollIntoView();
                }
            }
            $td.find('#countIndicator .count').html('<span class="fas fa-spinner fa-spin mr-1"></span>');
            $td.find('#resultSet').addClass('pause');
            $td.find('#resultSet').attr("aria-busy", true);
            spinner($td.find('#resultSet'));
            if (loadFacets && $td.find('#filterFacettenGruppen.loadIt').length) {
                $td.find('#filterFacettenGruppen').addClass('pause');
                $td.find('#filterFacettenGruppen').attr("aria-busy", true);
                spinner($td.find('#filterFacettenGruppen'));
                $('#labelManager').empty().html('<span class="fas fa-spinner fa-spin mr-1"></span>');
            }
            if (mobileMode) {
                $('#td #sortIndicator>span').text($('#td #sorting option:selected').text());
                $td.find('#filterFacetten .closeFilter .count').addClass('loading').html('<span class="fas fa-spinner fa-spin mr-1"></span>');
            }

        },
        success: function(response, status, xhr) {

            //console.log('SUCCESS');
            //console.log(response);
            //console.log(status);
            //console.log(xhr);
            if (updateState) {
                let newHashString = generateHashFromObject(params);
                // console.log(newHashString);
                // console.log(params);
                if (newHashString !== "#") { // pushState nur setzten, wenn irgendwelche Hashparams vorhanden sind!
                    history.pushState(params, '', window.location.pathname + window.location.search + newHashString); // absolute wegen baseUrl Thematik (ansonten würde relativ genügen)
                }
            }
            $td.find('#resultSet').html(response);
            checkMerkzettel();

            if (('#printList').length) {
                if ($td.find('.buchenFilter.v2').hasClass('emptyInitialBuchenBox-1')) {
                    params.startdate = '';
                    params.enddate = '';
                    params.occupation = '';
                    params.filterstate = 'all';
                }
                console.log('printList');
                console.log(params);
                $('#printList').prop('href', $('#printList').prop('href') + generateHashFromObject(params));
                $('body.tdListPrint #td .entry .web a').each(function(e) {
                    let url = $(this).text();
                    url = url.replace('http://', '');
                    url = url.replace('https://', '');
                    if (url.endsWith('/')) {
                        url = url.substr(0, url.length - 1);
                    }
                    $(this).text(url);
                });
            }

            if ($('#resultSet nav').length) {
                $('#countIndicator .count').text($('#resultSet nav').data('items'));
                $('#countIndicator').show().prop('title', 'Einträge ' + $('#resultSet nav').data('firstonthispage') + '-' + $('#resultSet nav').data('lastonthispage') + ' von ' + $('#resultSet nav').data('items'));
            } else {
                $('#countIndicator .count').text('0');
                $('#countIndicator').show().prop('title', '');
            }

            // eventuell optimieren und über GET Param steuern
            // $.each($('#td.mobileMode .trustYou'), function(k,v){
            //     let iframeSrc = $(this).find('iframe').prop('src');
            //     iframeSrc = iframeSrc.replace('size=s', 'size=xs');
            //     $(this).find('iframe').prop('src', iframeSrc);
            // });

            $('#resultSet .js-tooltip').each(function() {
                // Call the function with this as the current tooltip
                accessibleSimpleTooltipAria.apply(this);
            });

            trackSiteSearch(response, params, $td.data('type'));

        },
        error: function(xhr, status, error) {

            //console.log('ERROR');
            //console.log(xhr);
            //console.log(status);
            //console.log(error);
        },
        complete: function(xhr, status) {

            //console.log('COMPLETE');
            //console.log(xhr);
            //console.log(status);
            // $td.find('#resultSet').fadeIn();
            $td.find('#resultSet [data-toggle="tooltip"]').tooltip();
            pagingMagic($td.find('.pagination'));

            if (loadFacets && $td.find('#filterFacettenGruppen.loadIt').length) {
                getFacettenGruppen($td, params);
            }
            $td.find('.buchenFilter.v2 .buchenbox_button button').addClass('initialized');
            openingHours($td);
            waAuslastung($td);
            getLoipen($td);
            getReisezeitraum($td);

            if ($('#td.layout-kacheln')) {
                let $masonry = $td.find('.entries.kacheln').masonry({
                    itemSelector: '.entry'
                });
                setTimeout(function(e) {
                    $masonry.masonry('layout');
                    $td.find('#resultSet').removeClass('pause');
                    $td.find('#resultSet').attr("aria-busy", false);
                    // $td.removeClass('picLoadingIndication');
                }, 2000);
            } else {
                $td.find('#resultSet').removeClass('pause');
                $td.find('#resultSet').attr("aria-busy", false);
            }

            // Fallback, falls Sorting Dropdown leer ist (warum auch immer)
            // console.log($('#td.veranstaltung').data('unrollintervals'));
            if (!$('#sorting').val()) {
                if ($('#td.veranstaltung').data('unrollintervals') === 1) {
                    $('#sorting').val('interval_first_match+asc,title+asc');
                } else {
                    $('#sorting').val(params.sort);
                }
            }

            $td.removeClass('loading');

        }
    });

};

let searchTimeout = null;
const getMetaResultMaybeWithDelay = function(delay, hashObj) {

    if (delay > 0) {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function() {
            getMetaResult($('#td'), hashObj, true, true);
        }, delay);
    } else {
        getMetaResult($('#td'), hashObj, true, true);
    }

};

const openingHours = function($td) {

    // Öffungszeiten derzeit nur für Gastro
    if ($td.data('type') === 'Gastro' || $td.data('type') === 'POI' || $td.data('type') === 'All') {
        renderOpeningInfos();
    }
};

const getLoipen = function($td) {
    if ($td.data('type') === 'POI') {
        $('#resultSet .entry').each(function(index) {
            let obj, loipenWrapper, item;
            obj = $(this);
            item = {};
            loipenWrapper = obj.find('.td-loipen-wrapper');
            if (loipenWrapper.length > 0) {
                item.tourdataId = loipenWrapper.data('tourdataid');
                item.experienceId = loipenWrapper.data('experienceid');

                $.ajax({
                    type: "POST",
                    url: '/index.php?id=' + rootPage + '&type=1980&L=' + $('#td').data('syslanguageuid'),
                    data: "vars=" + JSON.stringify(item),
                    beforeSend: function() {
                        loipenWrapper.before('<span class="fas fa-circle-notch fa-spin"></span>');
                    },
                    success: function(result) {
                        loipenWrapper.html(result);
                    },
                    error: function() {
                        if (loipenWrapper.prev().hasClass('fa-circle-notch')) {
                            loipenWrapper.prev().remove();
                        }
                    },
                    complete: function(result) {
                        if (loipenWrapper.prev().hasClass('fa-circle-notch')) {
                            loipenWrapper.prev().remove();
                        }
                    }
                });

            }
        });
    }
};

const getReisezeitraum = function($td) {
    if ($td.data('type') === 'Package') {
        $('#resultSet .entry.tdpauschale').each(function(index) {
            let obj, rzWrapper, item;
            obj = $(this);
            item = {};
            rzWrapper = obj.find('.td-reisezeitraum-wrapper');
            if (rzWrapper.length > 0) {
                item.tourdataId = rzWrapper.data('tourdataid');
                item.experienceId = rzWrapper.data('experienceid');

                $.ajax({
                    type: "POST",
                    url: '/index.php?id=' + rootPage + '&type=1990&L=' + $('#td').data('syslanguageuid'),
                    data: "vars=" + JSON.stringify(item),
                    beforeSend: function() {
                        rzWrapper.before('<span class="fas fa-circle-notch fa-spin"></span>');
                    },
                    success: function(result) {
                        // console.log("SUCCESS");
                        // console.log(result);
                        rzWrapper.html(result);
                    },
                    error: function() {
                        if (rzWrapper.prev().hasClass('fa-circle-notch')) {
                            rzWrapper.prev().remove();
                        }
                    },
                    complete: function(result) {
                        if (rzWrapper.prev().hasClass('fa-circle-notch')) {
                            rzWrapper.prev().remove();
                            // console.log("completed");
                        }
                    }
                });

            }
        });
    }
};

const pagingMagic = function($pagination) {
    $.each($pagination, function(e) {
        const $nav = $(this).closest('nav');
        var back = $(this).closest('nav').data("seite-zurueck");
        var forward = $(this).closest('nav').data("seite-vor");
        var waehlen = $(this).closest('nav').data("seite-waehlen");

        if ($nav.data('items') > $nav.data('limit')) {
            $(this).pagination({
                edges: 1,
                items: $nav.data('items'),
                itemsOnPage: $nav.data('limit'),
                currentPage: parseInt($nav.data('active')) + 1,
                displayedPages: $nav.data('visiblepages'),
                cssStyle: '',
                prevText: '<span class="fa-regular fa-chevron-left" aria-hidden="true"></span><span class="sr-only">' + back + '</span>',
                nextText: '<span class="fa-regular fa-chevron-right" aria-hidden="true"></span><span class="sr-only">' + forward + '</span>',
                selectOnClick: false,
                onInit: function() {
                    $nav.find('li').addClass('page-item').find('a, span:not(.sr-only, .fa-regular)').addClass('page-link');
                    $nav.find('li .current').attr('aria-current', true);
                    $nav.find('li .ellipse ').attr('aria-label', waehlen);
                },
                onPageClick: function(pageNumber, event) {
                    if (event) { // wird nur bei Klick auf Seite ausgelöst - bei Eingabe über das Input (Punkterl) nicht
                        event.preventDefault();
                    }
                    let updateObj = {};
                    if ($('#td .buchenFilter').length) {
                        updateObj = getBuchenFilterValues(updateObj);
                    }
                    if ($('#td .pauschalenFilter').length) {
                        updateObj = getPauschalenFilterValues(updateObj);
                    }
                    updateObj.offset = (pageNumber - 1) * parseInt($nav.data('limit'));
                    updateObj.sort = $('#listOptions #sorting').val();
                    if (updateObj.sort === 'distance+asc') {
                        updateObj.latitude = $('#td').data('latlon').split(',')[0];
                        updateObj.longitude = $('#td').data('latlon').split(',')[1];
                    }
                    const newHashObj = generateNewHashObject(updateObj);
                    getMetaResult($('#td'), newHashObj, true, false);
                }
            });
        }
    });
};

const getFacettenGruppen = function($td, params) {

    // wenn $_GET['no_cache']=1 gesetzt ist, soll es metaResult Action übergeben werden, damit das Plugin-Caching deaktiviert werden kann
    const urlQueryString = window.location.search;
    const urlParams = new URLSearchParams(urlQueryString);

    let noCache = 0;
    if (urlParams.get('no_cache')) {
        noCache = 1;
    }

    const mobileMode = $('#td.mobileMode').length;
    let response = (parseInt($td.find('#resultSet').data('type')) === 1765) ? 'meta-hypersearch' : 'meta';

    let lang = $td.data('lang');
    let sysLanguageUid = $td.data('syslanguageuid');
    if (lang == "cz") {
        lang = "cs";
    }

    let initial = {};
    if ($td.data('anreise') && $td.data('abreise')) {
        initial.anreise = $td.data('anreise');
        initial.abreise = $td.data('abreise');
    }

    // appBaseUrl wird für die Streaming App benötigt
    let appBaseUrl = ($('#tdAppBaseUrl').data('appbaseurl')) ? $('#tdAppBaseUrl').data('appbaseurl') : '';

    // im Tannheimertal Webstream soll bei der Übergabe von startdate und enddate die emptyInitialBuchenbox entfernt werden (WEBSTREAM-156). Wenn man nach Reiszeitraum / Teilnehmer sucht sollen sofort buchbare Ergebnisse angezeigt werden
    if ($td.data('webstream') && $td.data('metaconfig') === 'tannheimertal' && params.startdate && params.enddate && !$td.find('.buchenFilter.v2').hasClass('emptyInitialBuchenBox-1')) {
        params.removeEmptyItems = 'true';
    }

    let emptyInitialBuchenBox = "";
    if ($td.find('.buchenFilter.v2').hasClass('emptyInitialBuchenBox-1')) {
        emptyInitialBuchenBox = ($td.find('.buchenFilter.v2').hasClass('emptyInitialBuchenBox-1')) ? '&emptyInitialBuchenBox=1' : '';
        // auch die Checkbox "direkt buchbare Unterkünfte" soll entfernt werden
    }

    console.log("##### emptyInitialBuchenBox #######");
    console.log(emptyInitialBuchenBox);
    console.log("### PARAMS ###");
    console.log(params);

    $.ajax({
        method: 'POST',
        url: appBaseUrl + "/index.php?id=" + rootPage + "&L=" + sysLanguageUid + "&response=" + response + "-facets&tdType=" + $td.data('type') + "&type=" + $td.find('#filterFacettenGruppen').data('type') + emptyInitialBuchenBox,
        // GET params only for identification in devTools
        data: {
            type: $td.find('#filterFacettenGruppen').data('type'),
            // t3 typeNum
            response: 'facets',
            tdType: $td.data('type'),
            tdTypeSub: $td.find('#filterFacettenGruppen').data('subtype'), // Webcams/Berichte (eig. nur für EventTracking)
            pageId: $td.data('pageid'),
            pluginUid: $td.data('pluginuid'),
            region: ($td.find('#regionsFilter').length) ? $td.find('#regionsFilter').val() : getRegionFromQparam(),
            // buchenFilter: (parseInt($td.find('#resultSet').data('type'))===1765) ? true : false,
            facettenGruppen: facettenGruppen,
            settings: $td.data('settings'),
            metaConfig: $td.data('metaconfig'),
            webstream: $td.data('webstream'),
            lang: lang,
            sysLanguageUid: sysLanguageUid,
            mode: getHashParameter('mode'),
            peoplecount: getHashParameter('peoplecount'),
            params: params,
            initial: initial,
            cachetime: $(td).data('cachetime'),
            noCache: noCache,
            buchenbox: $td.find('#filterFacettenGruppen').data('buchenbox'),
            pauschalenMetaFilter: $td.find('#filterFacettenGruppen').data('pauschalenmetafilter'),
            // searchStringNeutral: $td.data('searchstringneutral')
        },
        beforeSend: function(xhr, o) {

            // console.log('BEFORE');
            // console.log(o);
            // console.log(xhr);
            if (!$td.find('#filterFacettenGruppen.pause').length) {
                $td.find('#filterFacettenGruppen').addClass('pause');
                $td.find('#filterFacettenGruppen').attr("aria-busy", true);
                spinner($td.find('#filterFacettenGruppen'));
            }

        },
        success: function(response, status, xhr) {

            // console.log('SUCCESS');
            // console.log(response);
            // console.log(status);
            // console.log(xhr);

            // SETZE Werte basierend auf Hashtag
            const qParam = getHashParameter('q');
            const modeParam = getHashParameter('mode');
            const peoplecount = getHashParameter('peoplecount');

            $td.find('#filterFacettenGruppen').html(response);

            // response manipulieren > wenn gespeicherter Filter vorhanden/ersetzen
            const $savedFilter = $('#savedFilter .filter');
            if ($savedFilter.length) {
                const savedFilterID = $savedFilter.find('.collapse').prop('id');
                const $gruppeBasedOnResult = $td.find('#sortableFilter .gruppe #' + savedFilterID).closest('.gruppe');
                $savedFilter.insertBefore($gruppeBasedOnResult).show();
                $gruppeBasedOnResult.remove();
            }

            // Suchfeld
            if (qParam.indexOf('text:"') >= 0) {
                let qText = qParam.substr(qParam.indexOf('text:"')); // qParam ab text:"
                qText = qText.replace('text:"', ""); // entferne text:"
                const replaceAfter = qText.substr(qText.indexOf('"')); // zu entfernender String nach qText (folgt nach dem nun ersten Anführungzeichen)
                qText = qText.replace(replaceAfter, ""); // entferne nachfolgenden String, sodass nur qText=Suchstring über bleibt
                $td.find('.qText').val(qText).data('lastSearchVal', qText); // fülle Input mit Suchwort

                if ($('#filterFacetten').length) {
                    labelManager(
                        $td.find('.qText'), // $el
                        'text', // type
                        $td.find('.qText').prop('placeholder'), // gruppe
                        $td.find('.qText').prop('id'), // id
                        $.trim(qText) // text
                    );
                }
            }

            // selects (ort/region)
            $.each($td.find('select.form-control'), function(k, v) {

                const qKeyword = $(this).data('qkeyword');
                if (qParam.indexOf(qKeyword) >= 0) {
                    let string = qParam.substr(qParam.indexOf(qKeyword)).replace(qKeyword + ':"', "");
                    const value = string.substr(0, string.indexOf('"'));
                    $(this).val(value);

                    if ($('#filterFacetten').length) {
                        labelManager(
                            $(this), // $el
                            'select', // type
                            $(this).find('option[value=""]').text(), // gruppe
                            $(this).prop('id'), // id
                            $.trim($(this).find('option[value=' + value + ']').text()) // text
                        );
                    }
                }
            });

            // RangeSlider (Gesamtpreis & Touren)
            $.each($td.find('#filterFacettenGruppen .rangeSlider input'), function(k, v) {

                initRangeSlider($(v));

                const maxVal = $(v).bootstrapSlider('getAttribute').max;
                const umrechnung = parseInt($(v).data('umrechnung'));
                const qkeyword = $(v).data('qkeyword');

                if ((qParam.indexOf(qkeyword + ':') >= 0) || (params.pricefrom > -1 && params.priceto)) {

                    let valFromInt, valToInt, thisQValArr;

                    if ($(this).prop('id') === 'tdPreis') {

                        valFromInt = parseInt(params.pricefrom);
                        valToInt = parseInt(params.priceto);

                    } else if (qParam.indexOf(qkeyword + ':') >= 0) {
                        let thisQSub = qParam.substr(qParam.indexOf(qkeyword + ':'));
                        thisQSub = thisQSub.substr(0, thisQSub.indexOf(']'));
                        let thisQVal = thisQSub.replace(qkeyword + ':[', '');
                        thisQVal = thisQVal.replace(']', '');
                        thisQValArr = thisQVal.split(' TO ');

                        valFromInt = parseInt(thisQValArr[0]);
                        valToInt = parseInt(thisQValArr[1]);
                    }

                    if (valToInt || valFromInt) {

                        let valToString = valToInt / umrechnung;
                        if (parseInt(valToInt) >= maxVal || (Array.isArray(thisQValArr) && thisQValArr[1] == '*')) {
                            valToInt = maxVal;
                            valToString = maxVal / umrechnung + "+";
                        }

                        $(v).bootstrapSlider('setValue', [valFromInt, valToInt]);
                        $(v).closest('.rangeSlider').find('.von').text(valFromInt / umrechnung);
                        $(v).closest('.rangeSlider').find('.bis').text(valToString + " " + $(v).data('suffix'));

                        if ($('#filterFacetten').length) {
                            labelManager(
                                $(v), // $el
                                'slider', // type
                                $(v).closest('.rangeSlider').find('label .bezeichnung').text(), // gruppe
                                $(v).prop('id'), // id
                                $(v).closest('.rangeSlider').find('.von').text() + '-' + $(v).closest('.rangeSlider').find('.bis').text() // text
                            );
                        }
                    }
                }

            });

            $.each($td.find('#filterFacettenGruppen .numberFilter input'), function(k, v) {
                const qkeyword = $(v).data('qkeyword');
                if (qParam.indexOf(qkeyword + ':') >= 0) {
                    let valFromInt, valToInt, thisQValArr;

                    let thisQSub = qParam.substr(qParam.indexOf(qkeyword + ':'));
                    thisQSub = thisQSub.substr(0, thisQSub.indexOf(']'));
                    let thisQVal = thisQSub.replace(qkeyword + ':[', '');
                    thisQVal = thisQVal.replace(']', '');
                    thisQValArr = thisQVal.split(' TO ');

                    valFromInt = parseInt(thisQValArr[0]);
                    valToInt = parseInt(thisQValArr[1]);

                    if (valFromInt > 0) {
                        $(v).val(valFromInt);
                    }

                }
            });

            // Spezialfall fürs Tannheimertal


            // Nur Buchbare Checkbox
            console.log("################## PARAMS /// ##################");
            console.log(params);
            if (params.removeEmptyItems && params.removeEmptyItems === 'true') {
                checkFacet(false, $('div.form-check.nurBuchbare'));
                labelManager(
                    $('#td #tdNurBuchbare'), // $el
                    'checkbox', // type
                    '', // gruppe
                    'tdNurBuchbare', // id
                    $('#td #tdNurBuchbare').closest('div').find('.label').text() // text
                );
            }

            // Nur Anfragbar Checkbox
            if (params.filterstate && params.filterstate === 'requestableorneither') {
                checkFacet(false, $('div.form-check.nurAnfragbare'));
                labelManager(
                    $('#td #tdNurAnfragbare'), // $el
                    'checkbox', // type
                    '', // gruppe
                    'tdNurAnfragbare', // id
                    $('#td #tdNurAnfragbare').closest('div').find('.label').text() // text
                );
            }

            if ($('#zeitraumFilter').length > 0) {
                let today = formatDateforDatepicker(new Date());

                let splitDateVon = $('#metaQueryUrl').data('von').split(".");

                $('#zeitraumFilter input.form-control[name="zeitraumVon"]').prop({
                    'value': splitDateVon[2] + '-' + splitDateVon[1] + '-' + splitDateVon[0],
                    'min': today
                });

                let splitDateBis = $('#metaQueryUrl').data('bis').split(".");
                let bisMinDatum = new Date($('#zeitraumFilter input.form-control[name="zeitraumVon"]').val());
                bisMinDatum.setDate(bisMinDatum.getDate() + 1);
                bisMinDatum = formatDateforDatepicker(bisMinDatum);

                $('#zeitraumFilter input.form-control[name="zeitraumBis"]').prop({
                    'value': splitDateBis[2] + '-' + splitDateBis[1] + '-' + splitDateBis[0],
                    'min': bisMinDatum
                });

                $('#fixedFilter').on('click', '#zeitraumFilter a.suchen-btn', function(e) {
                    e.preventDefault();
                    trackEvent($('#fixedFilter').data('eventcatforjs'), 'Zeitraum', $('#fixedFilter .dpZeitraumVon').val() + '-' + $('#fixedFilter .dpZeitraumBis').val());
                    generateHashAndGetResult(e, $(this));
                });

                $('#zeitraumFilter input.form-control[name="zeitraumVon"]').change(function() {
                    let vonDatum = $(this).val();
                    let changedDatum = new Date(vonDatum);

                    // Abreisedatum holen
                    let bisDatum = $('#zeitraumFilter input.form-control[name="zeitraumBis"]').val();

                    // + 2 Tage und das bisDatum korrigieren
                    changedDatum.setDate(changedDatum.getDate() + 1);
                    changedDatum = formatDateforDatepicker(changedDatum);

                    // nur wenn das gewählte vonDatum größer als das hinterlegte bisDatum ist, soll das bisDatum um + 1 Tag erhöht werden
                    if (vonDatum >= bisDatum) {
                        // bisDatum darf nicht vor dem vonDatum liegen
                        $('#zeitraumFilter input.form-control[name="zeitraumBis"]').prop({
                            'value': changedDatum,
                            'min': changedDatum
                        });
                    } else {
                        // StartDate darf nicht vor dem vonDatum liegen
                        $('#zeitraumFilter input.form-control[name="zeitraumBis"]').prop({
                            'min': changedDatum
                        });
                    }
                });
            }

            let amountChecked = 0;
            let amountCheckboxes = 0;
            let checkedFacetObj;
            // Öffnungszeiten Checkboxen
            if ($('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"]').length) {
                amountChecked = $('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"] .facette.form-check.checked').length;
                amountCheckboxes = $('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"] .facette.form-check').length;
                // zumindest 1 Checkbox muss gesetzt sein
                if (amountChecked > 0) {
                    $.each($('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"] .facette.form-check'), function(k, v) {
                        // alle anderen Öffnungszeiten Checkboxen entfernen
                        if (!$(this).hasClass('checked')) {
                            $(this).remove();
                        }
                    });
                    checkedFacetObj = $('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"] .facette.form-check');
                    labelManager(
                        checkedFacetObj, // $el
                        'checkbox', // type
                        $.trim(checkedFacetObj.closest('.gruppe').find('.btn').text()), // gruppe
                        checkedFacetObj.find('input[data-keyword="mode"]').prop('id'), // id
                        checkedFacetObj.closest('.facette').find('label span.label').text() // text
                    );
                } else {
                    if (amountCheckboxes == 1) {
                        checkedFacetObj = $('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"] .facette.form-check');
                        checkFacet(false, checkedFacetObj.closest('div.form-check'));
                        labelManager(
                            checkedFacetObj, // $el
                            'checkbox', // type
                            $.trim(checkedFacetObj.closest('.gruppe').find('.btn').text()), // gruppe
                            checkedFacetObj.find('input[data-keyword="mode"]').prop('id'), // id
                            checkedFacetObj.closest('.facette').find('label span.label').text() // text
                        );
                    }
                }
            }

            // Auslastung Checkboxen
            if ($('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"]').length) {
                amountChecked = $('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"] .facette.form-check.checked').length;
                amountCheckboxes = $('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"] .facette.form-check').length;
                // zumindest 1 Checkbox muss gesetzt sein
                if (amountChecked > 0) {
                    $.each($('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"] .facette.form-check'), function(k, v) {
                        // alle anderen Öffnungszeiten Checkboxen entfernen
                        if (!$(this).hasClass('checked')) {
                            $(this).remove();
                        }
                    });
                    checkedFacetObj = $('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"] .facette.form-check');
                    labelManager(
                        checkedFacetObj, // $el
                        'checkbox', // type
                        $.trim(checkedFacetObj.closest('.gruppe').find('.btn').text()), // gruppe
                        checkedFacetObj.find('input[data-keyword="mode"]').prop('id'), // id
                        checkedFacetObj.closest('.facette').find('label span.label').text() // text
                    );
                } else {
                    if (amountCheckboxes == 1) {
                        checkedFacetObj = $('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"] .facette.form-check');
                        checkFacet(false, checkedFacetObj.closest('div.form-check'));
                        labelManager(
                            checkedFacetObj, // $el
                            'checkbox', // type
                            $.trim(checkedFacetObj.closest('.gruppe').find('.btn').text()), // gruppe
                            checkedFacetObj.find('input[data-keyword="mode"]').prop('id'), // id
                            checkedFacetObj.closest('.facette').find('label span.label').text() // text
                        );
                    }
                }
            }


            // Checkboxen
            $.each($td.find('.form-check-input:not("#tdNurBuchbare")'), function(k, v) {
                const keyword = $(this).closest('.gruppe').data('qkeyword');
                let val = '"' + $(this).data('qvalue') + '"'; // STRING > mit Quotes für exact Match
                if (keyword && (keyword.indexOf('number_') >= 0 || keyword.indexOf('rating_') >= 0)) {
                    val = $(this).data('qvalue'); // RANGE
                }
                const isQparamValueActive = qParam.indexOf(val);
                const isQparamKeywordActive = qParam.indexOf(keyword);
                if (isQparamValueActive >= 0 && isQparamKeywordActive >= 0) {

                    // Aktiviere Checkbox wenn Wert vorhanden
                    checkFacet(false, $(this).closest('div.form-check'));

                    // Öffne Facettengruppe wenn Facette darin gewählt ist
                    // $(this).closest('.gruppe').find('.btn.collapsed').removeClass('collapsed').next('.collapse').addClass('show'); // Bootstrap 4
                    $(this).closest('.gruppe').find('.btn.collapsed').removeClass('collapsed').next('.collapse').addClass('in'); // Bootstrap 3

                    if ($('#filterFacetten').length) {
                        labelManager(
                            $(this), // $el
                            'checkbox', // type
                            $.trim($(this).closest('.gruppe').find('.btn').text()), // gruppe
                            $(this).prop('id'), // id
                            $(this).closest('.facette').find('label span.label').text() // text
                        );
                    }

                }
            });

            // Öffne immer die ersten 3 Facettengruppen
            let i = 0;
            $.each($td.find('#sortableFilter .gruppe'), function(k, v) {
                if (i < 3) {
                    // $(this).find('.btn.collapsed').removeClass('collapsed').next('.collapse').addClass('show'); // Bootstrap 4
                    $(this).find('.btn.collapsed').removeClass('collapsed').next('.collapse').addClass('in'); // Bootstrap 3
                }
                i++;
            });

            // Sortierung im labelManager
            // if (mobileMode) {
            //     labelManager(
            //         $('#td #sorting'), // $el
            //         'sorting', // type
            //         $('#td #sorting option:disabled').text(), // gruppe
            //         'sorting', // id
            //         $('#td #sorting option:selected').text()// text
            //     );
            // }

            $('.filterAndFacets .js-tooltip').each(function() {
                // Call the function with this as the current tooltip
                accessibleSimpleTooltipAria.apply(this);
            });

        },
        error: function(xhr, status, error) {

            // console.log('ERROR');
            // console.log(xhr);
            // console.log(status);
            // console.log(error);
        },
        complete: function(xhr, status) {

            // console.log('COMPLETE');
            // console.log(xhr);
            // console.log(status);
            $td.find('#filterFacettenGruppen').removeClass('pause');
            $td.find('#filterFacettenGruppen').attr("aria-busy", false);
            $('#labelManager .fa-spinner').remove();
            if (mobileMode) {
                // $('#filterFacetten.show .closeFilter').trigger('click');
                $('#filterFacetten .closeFilter .count').removeClass('loading').text($('#countIndicator .count').text());
            } else {
                $td.find('#filterFacetten .collapse.in [data-toggle="tooltip"]').each(function() {
                    const wLabel = $(this).width();
                    const wSpan = $(this).find('span').width();
                    if (wLabel < wSpan) {
                        $(this).tooltip();
                    } else {
                        $(this).prop('title', '');
                    }
                });
                $td.find('#filterFacetten #tourenFilter [data-toggle="tooltip"]').tooltip();
                $('#filterFacetten').on('click', 'button.collapsed', function() {
                    const $el = $(this);
                    setTimeout(function() {
                        $el.next('.collapse').find('[data-toggle="tooltip"]').each(function() {
                            const wLabel = $(this).width();
                            const wSpan = $(this).find('span').width();
                            if (wLabel < wSpan) {
                                $(this).tooltip();
                            } else {
                                $(this).prop('title', '');
                            }
                        });
                    }, 500);
                });
            }

        }
    });

};

const spinner = function($elTo) {

    const $spinnerTemplate = $('.waTDlistResultlist.template');
    const $spinner = $spinnerTemplate.clone().removeClass('template');
    $elTo.prepend($spinner);

};

const checkFacet = function(e, el) {

    $check = (el) ? $(el) : $(this);

    if (e) { // CLICK (e=Event vorhanden)
        e.preventDefault();
        if ($check.find('.form-check-input').prop('checked') === true) {
            $check.find('.form-check-input').prop('checked', false).closest('.form-check').removeClass('checked').find('span.fa-light').removeClass('fa-check-square').addClass('fa-square');
        } else {
            $check.find('.form-check-input').prop('checked', true).closest('.form-check').addClass('checked').find('span.fa-light').removeClass('fa-square').addClass('fa-check-square');
        }
        generateHashAndGetResult(e, $(this));
        // Filtergruppe wird gecloned und gespeichert (sofern zumindest ein Wert der Gruppe gecheckt ist)
        // > um dieses Element nach laden der "neuen" FilterFacetten (unverändert) wieder einzufügen
        // > (bzw. den entsprechenden Teil zu ersetzen)
        // > Filtergruppe in der etwas geklickt wurde soll nicht verändert werden (=bestehen bleiben)
        // > Ausnahme: wenn letzter Wert der Gruppe entfernt wurde (dann lade auch diese Gruppe basierend am MetaResult neu)
        // > Logik des ersetzens wird getFacettenGruppen()/SUCCESS behandelt
        if ($check.closest('.filter.gruppe').find('.form-check-input:checked').length) {
            let $savedFilter = $('#savedFilter');
            $savedFilter.empty().append($check.closest('.filter.gruppe').clone().hide());
        }

    } else { // INITIAL (nach Laden der Facettengruppen)
        // Facette checken/unchecken
        if ($check.find('.form-check-input').prop('checked') === false) {
            $check.find('.form-check-input').prop('checked', true).closest('.form-check').addClass('checked').find('span.fa-light').removeClass('fa-square').addClass('fa-check-square');
        }

    }

};

const generateHashAndGetResult = function(e, $this) {

    if (e && ($this.hasClass('btn') || $this.closest('.buchenFilter.v2').length)) {
        e.preventDefault();
    }

    if ($this.prop('id') === "regionsFilter") {
        $('#ortsFilter').val(""); // Reset OrtsSelect wenn neue Region gewählt wird
    }

    let newHashObj = {
        q: qStringGenerator()
    };

    if ($('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"]').length) {
        if (modeGenerator() != '') {
            newHashObj.mode = modeGenerator();
        }
    }
    if ($('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"]').length) {
        if (peoplecountGenerator() != '') {
            newHashObj.peoplecount = peoplecountGenerator();
        }
    }
    if (newHashObj.q.length <= 0 || newHashObj.q == 'undefined') {
        delete newHashObj.q;
    }

    // hier wurde das #td vor .buchenFilter.v2 entfernt, da die BuchenFilterValues auch auf der Detailseite geladen werden müssen
    if ($('.buchenFilter.v2').length) {
        newHashObj = getBuchenFilterValues(newHashObj);
    }

    if ($('.pauschalenFilter.v2').length) {
        newHashObj = getPauschalenFilterValues(newHashObj);
    }

    if ($('#tdPreis').length) {
        const maxVal = parseInt($('#tdPreis').data('slider-max'));
        const toVal = (maxVal <= $('#tdPreis').bootstrapSlider('getValue')[1]) ? 9999 : $('#tdPreis').bootstrapSlider('getValue')[1];
        newHashObj.pricefrom = $('#tdPreis').bootstrapSlider('getValue')[0];
        newHashObj.priceto = toVal;
    }

    if ($('.form-check.nurBuchbare').hasClass('checked')) {
        newHashObj.removeEmptyItems = 'true';
    } else {
        newHashObj.removeEmptyItems = 'false';
    }

    if ($('#td .buchenFilter.v2').length) {
        if ($('.form-check.nurAnfragbare').hasClass('checked')) {
            newHashObj.filterstate = 'requestableorneither';
        } else {
            newHashObj.filterstate = 'all';
        }
    }

    if ($('#td .pauschalenFilter.v2').length) {
        newHashObj.filterstate = 'all';
    }

    if ((!$('#td .buchenFilter.v2').length && !$('#td .pauschalenFilter.v2')) || $('#td .buchenFilter.v2').hasClass('emptyInitialBuchenBox-1')) {
        delete newHashObj.removeEmptyItems;
    }

    if ($('#zeitraumFilter').length > 0) {
        let vonDate = $('#zeitraumFilter input.form-control[name="zeitraumVon"]').val();
        let bisDate = $('#zeitraumFilter input.form-control[name="zeitraumBis"]').val();

        newHashObj.startdate = vonDate;
        newHashObj.enddate = bisDate;
    }

    if ($('.pauschalenFilter.v2 input#pauschale-anreise').val()) {
        newHashObj.from = formatDateFromDatefield($('.pauschalenFilter.v2 input.dpAnreise').val());
        newHashObj.until = formatDateFromDatefield($('.pauschalenFilter.v2 input.dpAbreise').val());
        newHashObj.occupation = $('#p-occupation').val();
        console.log('### newHashObj ###');
        console.log(newHashObj);
    }

    if ($('#td.veranstaltung').length) {
        newHashObj.layout = ($('#listOptions button.ttgKachelnTab.active').length && $(window).width() >= 1170) ? 'kacheln' : 'liste';
    }

    // auf der globalen Suche auch den Suchbegriff ausgeben
    displaySearchValue(newHashObj);

    const delay = ($this.data('delay')) ? parseInt($this.data('delay')) : 0;

    if (window.location.hash.indexOf('ulm=true') >= 0) {
        newHashObj.ulm = true;
    }

    if ($this.closest('.buchenFilter.v2').data('mode') === 'ajax') {

        openListWithHash($this, newHashObj, ($this.closest('#ajaxBuchenFilterHolder').hasClass('tosc5booking') ? 'tosc5booking' : 'metabooking')); // metabooking

    } else {

        if ($('#listOptions #sorting').length) {

            newHashObj.sort = $('#listOptions #sorting').val();
            if (($('body').hasClass('ttg-tdTerminal') || newHashObj.ulm) && $('#td').data('latlon') && $('#td').data('latlon').length > 0) {

                // im Terminal sind die Koordinaten fix hinterlegt > Navigator muss/darf/soll nicht kontaktiert werden
                newHashObj.latitude = $('#td').data('latlon').split(',')[0];
                newHashObj.longitude = $('#td').data('latlon').split(',')[1];
                getMetaResultMaybeWithDelay(delay, newHashObj);

            } else if (newHashObj.sort === 'distance+asc' && (!newHashObj.latitude || !newHashObj.longitude) && navigator.geolocation) {

                navigator.geolocation.getCurrentPosition(
                    function(position) {

                        newHashObj.latitude = position.coords.latitude;
                        newHashObj.longitude = position.coords.longitude;
                        $('#td').attr('data-latlon', newHashObj.latitude + ',' + newHashObj.longitude);
                        getMetaResultMaybeWithDelay(delay, newHashObj);

                    },
                    function(error) {

                        geoLocationErrorOutput(error);
                        newHashObj.sort = "title+asc";
                        $('#listOptions #sorting option[value="' + newHashObj.sort + '"]').prop('selected', true);
                        getMetaResultMaybeWithDelay(delay, newHashObj);

                    }
                );

            } else {
                getMetaResultMaybeWithDelay(delay, newHashObj);
            }

        } else {

            if ($this.closest('.buchenFilter.v2').data('mode') === 'detail') {
                getDetailResults($this, newHashObj);
            } else {
                getMetaResultMaybeWithDelay(delay, newHashObj);
            }

        }

    }

};

const modeGenerator = function() {

    let mode = '';
    if ($('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"] .form-check-input:checked').val()) {
        mode = $('#td #filterFacetten .filter.gruppe[data-qKeyword="mode"] .form-check-input:checked').val();
    }

    return mode;

};

const peoplecountGenerator = function() {

    let peoplecount = '';
    if ($('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"] .form-check-input:checked').val()) {
        peoplecount = $('#td #filterFacetten .filter.gruppe[data-qKeyword="peoplecount"] .form-check-input:checked').val();
    }

    return peoplecount;

};

const qStringGenerator = function() {

    let qString = '';

    // Textstring
    qString += ($('#searchString').length && $('#searchString').val().length) ? 'text:"' + $('#searchString').val() + '"' : '';

    // Ort & Region
    $.each($('#td #filterFacetten select.form-control'), function(k, v) {
        if ($(this).val().length > 0) {
            const qKeyword = $(this).data('qkeyword');
            let qValue = '"' + $(this).val() + '"';
            // Ausnahme für Ausseerland - Bad Mitterndorf -> hier ist zip im Einsatz
            if (qKeyword === 'zip' && qValue === '"8983"') {
                qValue = '(8983 OR 8984)';
            }
            qString += (qString.length > 0) ? " AND " + qKeyword + ":" + qValue : qKeyword + ":" + qValue;
        }
    });

    // Facetten
    $.each($('#td #filterFacetten .facetten.gruppe .form-check-input:checked'), function(k, v) {
        qString += (qString.length > 0) ? " AND " + $(this).val() : $(this).val();
    });

    // Filter
    $.each($('#td #filterFacetten .filter.gruppe'), function(k, v) {

        if ($(this).data('qkeyword') != "mode" && $(this).data('qkeyword') != "peoplecount") {
            const $inputs = $(this).find('.form-check-input:checked');

            if ($inputs.length) {

                const qKeyword = $(this).data('qkeyword');
                qString += (qString.length > 0) ? " AND " + qKeyword + ":(" : qKeyword + ":(";
                let i = 0;
                $.each($inputs, function(k, v) {
                    const qValue = '"' + $(this).data('qvalue') + '"';
                    qString += (i > 0) ? " OR " + qValue : qValue;
                    i++;
                });
                qString += ")";
            }
        }
    });

    $.each($('#td #tourenFilter .rangeSlider input'), function(k, v) {

        const qKeyword = $(this).data('qkeyword');
        const maxVal = parseInt($(this).data('slider-max'));
        const toVal = (maxVal <= $(this).bootstrapSlider('getValue')[1]) ? '*' : $(this).bootstrapSlider('getValue')[1];

        if ($(this).bootstrapSlider('getValue')[0] === 0 && toVal === '*') {} else {
            const qValue = "[" + $(this).bootstrapSlider('getValue')[0] + " TO " + toVal + "]";
            qString += (qString.length > 0) ? " AND " + qKeyword + ":" + qValue : qKeyword + ":" + qValue;
        }

    });

    // für die generellen Rangeslider, welche über die Facettengruppen hinterlegt werden können
    $.each($('#td .rangeSliderFilter input'), function(k, v) {

        const qKeyword = $(this).data('qkeyword');
        const maxVal = parseInt($(this).data('slider-max'));
        const toVal = (maxVal <= $(this).bootstrapSlider('getValue')[1]) ? '*' : $(this).bootstrapSlider('getValue')[1];

        if ($(this).bootstrapSlider('getValue')[0] === 0 && toVal === '*') {} else {
            const qValue = "[" + $(this).bootstrapSlider('getValue')[0] + " TO " + toVal + "]";
            qString += (qString.length > 0) ? " AND " + qKeyword + ":" + qValue : qKeyword + ":" + qValue;
        }

    });

    // numberFilter, siehe STEYR-296
    $.each($('#td .numberFilter input'), function(k, v) {
        const qKeyword = $(this).data('qkeyword');
        if ($(this).val() > 0) {
            const qValue = "[" + $(this).val() + " TO " + $(this).attr('max') + "]";
            qString += (qString.length > 0) ? " AND " + qKeyword + ":" + qValue : qKeyword + ":" + qValue;
        }
    });

    return qString;

};

function setLanguage() {

    let lang = $('html').prop('lang');
    if (!lang) {
        lang = $('body').data('lang');
    }

    // wenn das lang Attribut zb. in der Form de-DE vorhanden ist (relevant bei Webstream Einbindungen)
    if (lang.indexOf('-') >= 0) {
        let tmpLang = lang.split('-');
        return tmpLang[0];
    }

    return lang;

}

const getBuchenFilterValues = function(hashObj) {

    // Buchen An und Abreise gibt es auf der Vermieter META + Vermieter Detailseite
    if ($('.buchenFilter.v2').length > 0 && $('.buchenFilter.v2.emptyInitialBuchenBox-1').length === 0) {
        hashObj.startdate = $('.buchenFilter.v2').data('startdate');
        hashObj.enddate = $('.buchenFilter.v2').data('enddate');
        hashObj.occupation = $('.buchenFilter.v2').data('occupation');
    }
    return hashObj;

};

const getPauschalenFilterValues = function(hashObj) {

    // Buchen An und Abreise gibt es auf der Pauschalen META Liste
    if ($('pauschalenFilter.v2').length > 0) {
        hashObj.from = $('pauschalenFilter.v2').data('from');
        hashObj.until = $('pauschalenFilter.v2').data('until');
        hashObj.occupation = $('pauschalenFilter.v2').data('occupation');
        hashObj.filterstate = 'all';
    }
    return hashObj;

};

const setAndGetPauschalenFilter = function(hashObj, $pF) {

    if (hashObj.from) {
        hashObj.startdate = hashObj.from;
    }

    if (hashObj.until) {
        hashObj.enddate = hashObj.until;
    }

    if (!hashObj.startdate) {
        hashObj.startdate = $pF.data('startdate');
    } else {
        $pF.find('input.dpAnreise').val(formatDateFromHash(hashObj.startdate));
    }

    if (!hashObj.enddate) {
        hashObj.enddate = $pF.data('enddate');
    } else {
        $pF.find('input.dpAbreise').val(formatDateFromHash(hashObj.enddate));
    }

    if (hashObj.startdate && hashObj.enddate) {
        sumUpZeitraum($pF);
    }

    if (!hashObj.occupation) {
        hashObj.occupation = $pF.data('occupation');
    } else {
        $pF.find('input#p-occupation').val(hashObj.occupation);
    }

    if (!hashObj.filterstate) {
        hashObj.filterstate = 'all';
    }

    return hashObj;

};

const setAndGetBuchenFilter = function(hashObj, $bF) {

    let lang = setLanguage();

    if (!hashObj.startdate) {
        hashObj.startdate = $bF.data('startdate');
    } else {
        $bF.find('input.dpAnreise').val(formatDateFromHash(hashObj.startdate));
    }

    if (!hashObj.enddate) {
        hashObj.enddate = $bF.data('enddate');
    } else {
        $bF.find('input.dpAbreise').val(formatDateFromHash(hashObj.enddate));
    }

    if (hashObj.startdate && hashObj.enddate) {
        sumUpAnAbreise($bF);
    }

    if (!hashObj.occupation) {
        hashObj.occupation = $bF.data('occupation');
    } else {
        generateReiseteilnehmerOutOfHash($bF, hashObj.occupation);
    }

    return hashObj;

};

const getRegionFromQparam = function() {

    const q = getHashParameter('q');
    const posArea = q.indexOf('number_RegionID:"');
    if (posArea === -1) {
        return '';
    }

    let area = q.substr(posArea + 17);
    const posAreaEnd = area.indexOf('"');
    // area = area.substr(0,posAreaEnd);
    return area.substr(0, posAreaEnd);

};

const initRangeSlider = function($el) {

    const $inputEl = ($el) ? $el : $(this);
    const umrechnungsKey = ($inputEl.data('umrechnung')) ? parseInt($inputEl.data('umrechnung')) : 1;
    const slider = $inputEl.bootstrapSlider({
        handle: 'square',
        tooltip: 'hide'
    }).on('slideStart', function(v) {
        // if ($inputEl.closest('.rangeSlider').hasClass('fixedMax')) {
        //     if (v.value[1] < parseInt($inputEl.data('slider-max'))) {
        //         $(v.target).bootstrapSlider('setValue', [v.value[1], parseInt($inputEl.data('slider-max'))]);
        //     }
        // }
    }).on('slide', function(v) {
        if ($inputEl.closest('.rangeSlider').hasClass('fixedMax')) {
            if (v.value[1] < parseInt($inputEl.data('slider-max'))) {
                $(v.target).bootstrapSlider('setValue', [v.value[1], parseInt($inputEl.data('slider-max'))]);
            }
        }
        const maxVal = slider.bootstrapSlider('getAttribute').max;
        const valFrom = v.value[0];
        let valTo = v.value[1];
        $inputEl.closest('.rangeSlider').find('.von').text(valFrom / umrechnungsKey);
        valTo = (valTo >= maxVal) ? maxVal / umrechnungsKey + "+" : valTo / umrechnungsKey;
        $inputEl.closest('.rangeSlider').find('.bis').text(valTo + " " + $inputEl.data('suffix'));
    }).on('slideStop', function(v) {
        if ($inputEl.closest('.rangeSlider').hasClass('fixedMax')) {
            if (v.value[1] < parseInt($inputEl.data('slider-max'))) {
                $(v.target).bootstrapSlider('setValue', [v.value[1], parseInt($inputEl.data('slider-max'))]);
            }
        }
        generateHashAndGetResult(false, $(this));
        if ($inputEl.closest('#tourenFilter').length) {
            trackEvent('TOURDATA Liste (Tour)', 'Touroption (' + v.currentTarget.id + ')', (v.value[0] / umrechnungsKey) + '-' + (v.value[1] / umrechnungsKey) + ' ' + $inputEl.data('suffix'));
        } else {
            trackEvent('Unterkunftssuche Buchenbox', 'Preisbereich', (v.value[0] / umrechnungsKey) + '-' + (v.value[1] / umrechnungsKey) + ' ' + $inputEl.data('suffix'));
        }
    });

    // Init Label Values
    const maxVal = slider.bootstrapSlider('getAttribute').max;
    let values = slider.data('value').split(',');
    $inputEl.closest('.rangeSlider').find('.von').text(values[0] / umrechnungsKey);
    values[1] = (values[1] >= maxVal) ? maxVal / umrechnungsKey + "+" : values[1] / umrechnungsKey;
    $inputEl.closest('.rangeSlider').find('.bis').text(values[1] + " " + $inputEl.data('suffix'));

};

const geoLocationErrorOutput = function(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.log("User denied the request for Geolocation.");
            break;
        case error.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable.");
            break;
        case error.TIMEOUT:
            console.log("The request to get user location timed out.");
            break;
        case error.UNKNOWN_ERROR:
            console.log("An unknown error occurred.");
            break;
    }
};

const labelManager = function($el, type, gruppe, id, text) {

    if (!$el) {

        // init labelManager
        let $labelManager = $('<div />').prop('id', 'labelManager').html('<span class="fas fa-spinner fa-spin mr-1"></span>');
        $labelManager.insertAfter($('#td #listOptions'));

    } else {

        let $tag = $('<span />').prop('id', 'tag_' + id).addClass('tag type_' + type).data({
            'gruppe': gruppe,
            'type': type
        }).click(function() {
            switch (type) {
                case 'checkbox':
                    if (id !== 'tdNurBuchbare' && id !== 'tdNurAnfragbare') {
                        $el.closest('.form-check').trigger('click');
                    }
                    break;
                case 'text':
                    $el.val('');
                    $('#searchStringFilter .btn').trigger('click');
                    break;
                case 'select':
                    $el.val('').trigger('change');
            }
        });
        if (type != 'slider' && type != 'sorting' && type != 'anAbreise' && type != 'personen' && id != 'tdNurBuchbare' && id != 'tdNurAnfragbare') {
            $tag.append($('<span class="fas fa-times"></span>'));
        } else {
            // bei "unlöschbaren" Filtern/Facetten Filteroverlay öffnen
            $tag.click(function() {
                $('#triggerFilter').trigger('click');
            }).addClass('noDeleteOption');
        }
        if (gruppe != '') {
            $tag.append(
                $('<span />').addClass('gruppe').text(gruppe + ":")
            );
        }
        $tag.append(
            $('<span />').addClass('text').text(text)
        );

        if ($('#' + id).closest('.buchenFilter').length) {
            $tag.addClass('projectColored');
        }

        $('#labelManager').append($tag);

    }

};

const calcNights = function(an, ab) {
    // console.log(an);
    // console.log(ab);
    let nights = 2;
    const anDate = new Date(an);
    const abDate = new Date(ab);
    // console.log(anDate);
    // console.log(abDate);
    nights = (abDate - anDate) / 1000 / 60 / 60 / 24;
    // console.log(nights);
    return nights;
};

const addRoom = function($el, hashBasedErw, hashBasedKids) {
    const $zimmerHolder = $el.find('.zimmerHolder');
    const roomCount = $zimmerHolder.find('.zimmer:not(".template")').length;

    // Add Room Button aus-/einblenden (max 3 Zimmer)
    if (roomCount === 2) {
        $el.find('button.addRoom').hide();
    }

    // Del Btn bei nur 1 Raum ausblenden
    if (roomCount === 0) {
        $zimmerHolder.find('.delRoom').hide();
    } else {
        $zimmerHolder.find('.delRoom').show();
    }

    const $zimmerTemplate = $zimmerHolder.find('.zimmer.template');
    let $newRoom = $zimmerTemplate.clone();
    $newRoom.removeClass('template');
    $newRoom.find('.zimmerNr').text(roomCount + 1);
    $newRoom.find('.delRoom').click(function(e) {
        e.preventDefault();
        delRoom($newRoom);
    });
    $.each($newRoom.find('.smartCountInput'), function(k, v) {

        let valInt = parseInt($(this).data('initval'));
        let minValInt = parseInt($(this).data('minval'));
        let maxValInt = parseInt($(this).data('maxval'));

        if ($(this).hasClass('erwachsene') && hashBasedErw) {

            valInt = parseInt(hashBasedErw);

        }

        if ($(this).hasClass('kinder') && hashBasedKids) {

            // Handling wenn Occupation mit Kinder im Hash
            const hashBasedKidsArr = hashBasedKids.split(',');
            valInt = hashBasedKidsArr.length;
            const $kinderTemplate = $newRoom.find('.kinderHolder .kind.template');
            $.each(hashBasedKidsArr, function(k, v) {
                let $kinderAlterInput = $kinderTemplate.clone();
                $kinderAlterInput.removeClass('template');
                $kinderAlterInput.find('.kindAlter').prop('placeholder', $kinderAlterInput.find('.kindAlter').prop('placeholder') + ' ' + (k + 1)).val(v);
                $kinderAlterInput.appendTo($newRoom.find('.kinderHolder .row'));
            });

        }

        let label = $(this).prop('placeholder');
        if (valInt === 1) {
            label = $(this).data('singular');
        }

        // Set Value
        $(this).val(valInt + ' ' + label);

        // Bind Click Function
        $(this).closest('.input-group').find('a').click(function(e) {
            e.preventDefault();
            smartCountV2($(this));
        });

        // Initiales ausblenden von +/i wenn min-/maxVal
        if (valInt === minValInt) {
            $(this).closest('.input-group').find('a.btn-minus span').hide();
        }
        if (valInt === maxValInt) {
            $(this).closest('.input-group').find('a.btn-plus span').hide();
        }

    });
    $newRoom.appendTo($zimmerHolder);
};

const delRoom = function($room) {
    const $zimmerHolder = $room.closest('.zimmerHolder');
    const $el = $zimmerHolder.closest('.magic');

    $room.remove();
    const roomCount = $zimmerHolder.find('.zimmer:not(".template")').length;

    // Add Room Button aus-/einblenden (max 4 Zimmer)
    if (roomCount < 4) {
        $el.find('button.addRoom').show();
    }

    // Del Btn bei nur 1 Raum ausblenden
    if (roomCount === 1) {
        $zimmerHolder.find('.delRoom').hide();
    }

    i = 0;
    $.each($zimmerHolder.find('.zimmer'), function(k, v) {
        $(this).find('.zimmerNr').text(i);
        i++;
    });
};

const smartCountV2 = function($el) {
    const $input = $el.closest('.input-group').find('input');
    const actValInt = parseInt($input.val());
    const minValInt = parseInt($input.data('minval'));
    const maxValInt = parseInt($input.data('maxval'));

    let newValInt = actValInt - 1;
    if ($el.hasClass('btn-plus')) {
        newValInt = actValInt + 1;
    }

    if ($el.hasClass('btn-minus')) {
        $el.closest('.input-group').find('.btn-plus span').show();
        if (newValInt === minValInt) {
            $el.find('span').hide();
        } else {
            $el.find('span').show();
        }
    }

    if ($el.hasClass('btn-plus')) {
        $el.closest('.input-group').find('.btn-minus span').show();
        if (newValInt === maxValInt) {
            $el.find('span').hide();
        } else {
            $el.find('span').show();
        }
    }

    let label = $input.prop('placeholder');
    if (newValInt === 1) {
        label = $input.data('singular');
    }

    const newValText = newValInt + ' ' + label;
    $input.val(newValText);
    trackEvent('Unterkunftssuche Buchenbox', 'Anzahl ' + label, newValInt);

    if ($el.closest('.input-group').hasClass('kinder')) {
        kinderAlterHackV2($el.closest('.zimmer'));
    }
};

const kinderAlterHackV2 = function($zimmer) {
    const kinderCount = parseInt($zimmer.find('.smartCountInput.v2.kinder').val());
    const actVisibleKinderAlter = $zimmer.find('.kinderHolder .kind:not(".template")').length;
    const $kinderTemplate = $zimmer.find('.kinderHolder .kind.template');
    if (actVisibleKinderAlter < kinderCount) {
        let $kinderAlterInput = $kinderTemplate.clone();
        $kinderAlterInput.removeClass('template');
        $kinderAlterInput.find('.kindAlter').prop('placeholder', $kinderAlterInput.find('.kindAlter').prop('placeholder') + ' ' + kinderCount);
        $kinderAlterInput.appendTo($zimmer.find('.kinderHolder .row'));
    } else {
        $zimmer.find('.kinderHolder .row .kind:last-child()').remove();
    }
};

const sumUpReiseteilnehmer = function($reiseTeilnehmer, $btn) {
    let kidsValid = true;
    $.each($reiseTeilnehmer.find('.zimmer .kinderHolder .kind:not(".template") .kindAlter'), function(k, v) {
        if ($(this).val().length === 0) {
            kidsValid = false;
            $(this).addClass('invalid');
        } else {
            $(this).removeClass('invalid');
        }
    });
    if (kidsValid) {
        let zimmer = 0;
        let erwachsene = 0;
        let kinder = 0;

        zimmer = $reiseTeilnehmer.find('.zimmer:not(".template")').length;
        $.each($reiseTeilnehmer.find('.zimmer:not(".template") .erwachsene .smartCountInput'), function(k, v) {
            erwachsene = erwachsene + parseInt($(this).val());
        });
        $.each($reiseTeilnehmer.find('.zimmer:not(".template") .kinder .smartCountInput'), function(k, v) {
            kinder = kinder + parseInt($(this).val());
        });

        $reiseTeilnehmer.find('.sumUp_zimmer').text(zimmer);
        $reiseTeilnehmer.find('.sumUp_erwachsene').text(erwachsene);
        $reiseTeilnehmer.find('.sumUp_kinder').text(kinder);

        if ($btn && $btn.hasClass('ok')) {
            trackEvent('Unterkunftssuche Buchenbox', 'Reiseteilnehmer', 'Zimmer: ' + zimmer + ', Erwachsene: ' + erwachsene + ', Kinder: ' + kinder);
            $reiseTeilnehmer.closest('.buchenFilter.v2').removeClass('emptyInitialBuchenBox-1');
        }

        if (zimmer === 1) {
            $reiseTeilnehmer.find('.sumUp_zimmer_singularPlural').text(' ' + $reiseTeilnehmer.find('.sumUp_zimmer_singularPlural').data('singular'));
        } else {
            $reiseTeilnehmer.find('.sumUp_zimmer_singularPlural').text(' ' + $reiseTeilnehmer.find('.sumUp_zimmer_singularPlural').data('plural'));
        }

        if (erwachsene === 1) {
            $reiseTeilnehmer.find('.sumUp_erwachsene_singularPlural').text(' ' + $reiseTeilnehmer.find('.sumUp_erwachsene_singularPlural').data('singular'));
        } else {
            $reiseTeilnehmer.find('.sumUp_erwachsene_singularPlural').text(' ' + $reiseTeilnehmer.find('.sumUp_erwachsene_singularPlural').data('plural'));
        }

        if (kinder === 1) {
            $reiseTeilnehmer.find('.sumUp_kinder_singularPlural').text(' ' + $reiseTeilnehmer.find('.sumUp_kinder_singularPlural').data('singular'));
        } else {
            $reiseTeilnehmer.find('.sumUp_kinder_singularPlural').text(' ' + $reiseTeilnehmer.find('.sumUp_kinder_singularPlural').data('plural'));
        }
    }
    generateOccupationString($reiseTeilnehmer.closest('.buchenFilter.v2'));
    return kidsValid;
};

const generateOccupationString = function($bF) {
    let occupationString = "";
    $.each($bF.find('.zimmerHolder .zimmer:not(".template")'), function(k, v) {
        let zimmer = "";

        let erw = parseInt($(this).find('.smartCountInput.v2.erwachsene').val());
        erw = erw.toString();

        let kinder = "";
        $.each($(this).find('.kind:not(".template") .kindAlter'), function(k, v) {
            kinder = (kinder.length > 0) ? kinder + ',' + parseInt($(this).val()) : parseInt($(this).val());
            kinder = kinder.toString();
        });

        zimmer = (kinder.length > 0) ? erw + ':' + kinder : erw;
        zimmer = zimmer.toString();

        occupationString = (occupationString.length > 0) ? occupationString + '+' + zimmer : zimmer;
    });
    $bF.data('occupation', occupationString);
};

const generateStartEndDate = function($bF) {
    $bF.data('startdate', formatDateFromDatefield($bF.find('input.dpAnreise').val()));
    $bF.data('enddate', formatDateFromDatefield($bF.find('input.dpAbreise').val()));
};

// für Pauschalen-META
const sumUpZeitraum = function($pF, $btn) {
    $pF.find('.sumUpData .sumUp_an').text(formatDateFromDatefield($pF.find('input.dpAnreise').val()));
    $pF.find('.sumUpData .sumUp_ab').text(formatDateFromDatefield($pF.find('input.dpAbreise').val()));
    generateStartEndDate($pF);
};

const sumUpAnAbreise = function($bF, $btn) {
    // console.log($btn);
    $bF.find('.sumUpData .sumUp_an').text(formatDateFromDatefield($bF.find('input.dpAnreise').val()));
    $bF.find('.sumUpData .sumUp_ab').text(formatDateFromDatefield($bF.find('input.dpAbreise').val()));
    const nights = Math.round(calcNights($bF.find('input.dpAnreise').val(), $bF.find('input.dpAbreise').val()));
    $bF.find('.sumUpData .sumUp_tage').text(nights);
    if (calcNights($bF.find('input.dpAnreise').val(), $bF.find('input.dpAbreise').val()) > 1) {
        $bF.find('.sumUp_plural').show();
        $bF.find('.sumUp_singular').hide();
    } else {
        $bF.find('.sumUp_plural').hide();
        $bF.find('.sumUp_singular').show();
    }
    generateStartEndDate($bF);

    if ($btn && $btn.hasClass('ok')) {
        trackEvent('Unterkunftssuche Buchenbox', 'Dauer', 'Nächte: ' + nights);
        $bF.removeClass('emptyInitialBuchenBox-1');
    }
};

const generateReiseteilnehmerOutOfHash = function($bF, occupation) {
    let occupationArr = occupation.split('+');
    $.each(occupationArr, function(k, zimmer) {

        let zimmerArr = zimmer.split(':');
        addRoom($bF.find('.buchenbox_reiseTeilnehmer'), zimmerArr[0], zimmerArr[1]);

    });
    sumUpReiseteilnehmer($bF.find('.buchenbox_reiseTeilnehmer'));
};

const getDetailResults = function($btn, hash) {
    let params = $.extend({}, hash);

    params.q = 'sourceid:' + $btn.data('sourceid');
    params.mkt = $btn.data('lang');

    if ($btn.data('bookingurl')) {
        params.bookingUrl = $btn.data('bookingurl');
    }

    params.emailIfNoBooking = $('#ttgTourdataKontakt address a[href="#mailto"]').data('href');

    $.ajax({
        type: "POST",
        url: '/index.php?type=1767&id=' + $btn.data('pageuid') + "&L=" + $btn.data('syslanguageuid'),
        data: {
            params: params
        },
        beforeSend: function() {
            $('#ttgBuchenDetailResponse').addClass('pause');
            $('#ttgBuchenDetailResponse').attr("aria-busy", true);
            spinner($('#ttgBuchenDetailResponse'), 'lds-roller');
        },
        success: function(result) {
            $('#ttgBuchenDetailResponse .result').html(result);
            $('#ttgBuchenDetailResponse .loadingAnimation').remove();

            let newHashString = generateHashFromObject(hash);
            if (newHashString !== "#" && newHashString !== window.location.hash) { // pushState nur setzten, wenn irgendwelche Hashparams vorhanden sind und Params nicht gleich dem aktuellem Hash sind!
                history.pushState(hash, '', window.location.pathname + window.location.search + newHashString); // absolute wegen baseUrl Thematik (ansonten würde relativ genügen)
            }
        },
        error: function() {
            //alert("error");
        },
        complete: function() {
            $.each($('#ttgBuchenDetailResponse .nothingFound a'), function() {
                if ($(this).height() === 22) {
                    $(this).addClass('oneLine');
                }
            });

            if ($(window).width() > 991 && $(window).width() < 1200 && $('#ttgBuchenDetailResponse .result').prop('scrollHeight') > 80) {
                $('#ttgBuchenDetailResponse .showMoreIndication').removeClass('d-none');
            } else if ($('#ttgBuchenDetailResponse .result').prop('scrollHeight') > 172) {
                $('#ttgBuchenDetailResponse .showMoreIndication').removeClass('d-none');
            } else {
                $('#ttgBuchenDetailResponse .showMoreIndication').addClass('d-none');
            }
            $('#ttgBuchenDetailResponse .showMoreIndication').click(function(e) {
                e.preventDefault();
                $('#ttgBuchenDetailResponse').toggleClass('open');
            });

            $('#ttgBuchenDetailResponse').removeClass('pause');
            $('#ttgBuchenDetailResponse').attr("aria-busy", false);
        }
    });
};

const ajaxBuchenFilter = function(id) {

    if ($('#ajaxBuchenFilter').length) {

        if ($('#ajaxBuchenFilter').hasClass('showBooking')) {
            $('#ajaxBuchenFilter').removeClass('showBooking').closest('.ttgUKQuickNavi').find('h3').removeClass('showBooking');
            // Mobile Fix (switch zw. Mobile & Desktop)
            $('body').removeClass('blackout');
            $('#mobileBottomTrigger ul').removeClass();
        } else {
            $('#ajaxBuchenFilter').addClass('showBooking').closest('.ttgUKQuickNavi').find('h3').addClass('showBooking');
            // Mobile Fix (switch zw. Mobile & Desktop)
            $('body').addClass('blackout');
            $('#mobileBottomTrigger ul').addClass('show booking');
        }

    } else {

        let lang = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguage');
        let sysLanguageUid = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguagesysuid');
        if (lang == "cz") {
            lang = "cs";
        }

        $.ajax({
            type: "POST",
            url: '/index.php?id=' + rootPage + '&type=1777&L=' + sysLanguageUid,
            data: {
                lang: lang,
                sysLanguageUid: sysLanguageUid,
                L: sysLanguageUid
            },
            // beforeSend: function() {},
            success: function(result) {
                $('#' + id + 'Holder').append(result);
            },
            // error: function() {},
            complete: function() {
                initbFv2($('#ajaxBuchenFilter').find('.buchenFilter.v2'));
                $('#ajaxBuchenFilter').find('.buchenFilter.v2 .buchenbox_button button').addClass('initialized');
                // $('#ajaxBuchenFilter')
                // .addClass('showBooking')
                // .find('.buchenbox_button button').height($('#ajaxBuchenFilter').find('.magicHolder').height() - 24);
                // $('#ajaxBuchenFilter').closest('.ttgUKQuickNavi').find('h3').addClass('showBooking');
                // Mobile Fix (switch zw. Mobile & Desktop)
                // $('body').addClass('blackout');
                // $('#mobileBottomTrigger ul').addClass('show booking');
            }
        });

    }

};

const openListWithHash = function($btn, hash, mode) {
    switch (mode) {
        case 'metabooking':
            window.location.href = $btn.closest('#ajaxBuchenFilter').data('bookinglisturl') + generateHashFromObject(hash);
            break;

        case 'tosc5booking':
            dw.accommodationQuickFind(
                $btn.closest('.buchenFilter.v2').data('tosc5linkkey'),
                translateHash2tosc5reisedaten(hash),
                function() {
                    window.location.href = $btn.closest('#ajaxBuchenFilter').data('bookinglisturl');
                }
            );
            break;
    }
};

const translateHash2tosc5reisedaten = function(hash) {
    const von = hash.startdate.split('.');
    const bis = hash.enddate.split('.');
    let reisedaten = {
        dateFrom: new Date(von[2], (von[1] - 1), von[0]),
        dateTo: new Date(bis[2], (bis[1] - 1), bis[0])
    };

    const ziArr = hash.occupation.split('+');

    $.each(ziArr, function(i, zimmer) {
        const persArr = zimmer.split(':');

        let children = [];
        if (persArr[1]) {
            const kidsArr = persArr[1].split(',');
            $.each(kidsArr, function(ik, kid) {
                children[ik] = parseInt(kid);
            });
        }

        if (i === 0) {
            reisedaten.occupancy1 = {
                units: 1,
                adults: parseInt(persArr[0]),
                children: children
            };
        }
        if (i === 1) {
            reisedaten.occupancy2 = {
                units: 1,
                adults: parseInt(persArr[0]),
                children: children
            };
        }
        if (i === 2) {
            reisedaten.occupancy3 = {
                units: 1,
                adults: parseInt(persArr[0]),
                children: children
            };
        }

    });

    return reisedaten;
};

// Bei der globalen Seitensuche soll der Suchbegriff ausgegeben werden
const displaySearchValue = function(hashObj) {
    let searchValue, searchHeadline = '';
    if ($('.search-query-field').length > 0) {
        if (hashObj.q && hashObj.q !== 'text:""') {
            searchHeadline = $('.search-headline').data('search-text-with-query');
            $('.search-text').html(searchHeadline);
            searchValue = hashObj.q.replace('text:', '');
            $('.search-query-field').html(escapeOutput(searchValue));
        } else {
            if (hashObj.q) {
                hashObj.q.replace('text:', '');
                hashObj.q = '';
            }
            searchHeadline = $('.search-headline').data('search-text-no-query');
            $('.search-text').html(searchHeadline);
            $('.search-query-field').html('');
        }
    }
};

// Escape String für Ausgabe im Frontend (XSS Prevention)
const escapeOutput = function(output) {
    /* jshint ignore:start */
    return output.replace(/\&/g, '&amp;')
        .replace(/\</g, '&lt;')
        .replace(/\>/g, '&gt;')
        .replace(/\"/g, '&quot;')
        .replace(/\'/g, '&#x27')
        .replace(/\//g, '&#x2F');
    /* jshint ignore:end */
};

const initPauschalenv2 = function($pF) {
    if ($pF.length) {

        let todayNr = moment().isoWeekday();
        let today, tomorrow;
        today = moment().isoWeekday(todayNr).format('YYYY-MM-DD');
        tomorrow = moment().isoWeekday(todayNr).add('days', 1).format('YYYY-MM-DD');

        // Datum für heute + morgen per JS setzen (Caching)
        // Datum für nächsten Freitag + Sonntag per JS setzen (Caching)
        $pF.find('input.dpAnreise').val(today).attr('min', today);
        $pF.find('input.dpAbreise').val(tomorrow).attr('min', tomorrow);

        $pF.find('.magic-zeitraum button').click(function(e) {

            sumUpZeitraum($pF, $(this));

            if ($(this).closest('.magicHolder').hasClass('show')) {
                $(this).closest('.magicHolder').removeClass('show');
                $(this).attr('aria-expanded', false);
                $pF.find('.pauschalen-box-btn button').prop('disabled', false);
            } else {
                $pF.find('.magicHolder').addClass('show');
                $(this).attr('aria-expanded', true);
                let topPos = $(this).height() + 55; // Height of Button + Padding - 3px um direkt darunter zu positionieren, aber leicht überlagert damit es seamless aussieht
                $(this).closest('.magicHolder').addClass('show').find('.magic').css({
                    'top': topPos + 'px'
                });
                $pF.find('.pauschalen-box-btn button').prop('disabled', true);
            }
        });

        $pF.find('input.dpAnreise').change(function() {
            if (new Date($(this).val()).getTime() > new Date($pF.find('input.dpAbreise').val()).getTime()) {
                $pF.find('input.dpAbreise').val(moment($(this).val()).add('days', 1).format('YYYY-MM-DD'));
            }
            $pF.find('input.dpAbreise').attr('min', moment($(this).val()).add('days', 1).format('YYYY-MM-DD'));
        });

        generateStartEndDate($pF);
        $pF.data('occupation', $('#p-occupation').val());

        hashObj = setAndGetPauschalenFilter(hashObj, $pF);
    }
};

const initbFv2 = function($bF) {

    if ($bF.length) {

        let nextFridayNr = 5;
        let nextFriday, nextSunday;
        let today = moment().format('YYYY-MM-DD');
        let tomorrow = moment().add('days', 1).format('YYYY-MM-DD');
        if (moment().isoWeekday() <= nextFridayNr) {
            nextFriday = moment().isoWeekday(nextFridayNr).format('YYYY-MM-DD');
            nextSunday = moment().isoWeekday(nextFridayNr).add('days', 2).format('YYYY-MM-DD');
        } else {
            // nächste Woche
            nextFriday = moment().isoWeekday(nextFridayNr).add('weeks', 1).format('YYYY-MM-DD');
            nextSunday = moment().isoWeekday(nextFridayNr).add('days', 9).format('YYYY-MM-DD');
        }

        // Datum für nächsten Freitag + Sonntag per JS setzen (Caching)
        $bF.find('input.dpAnreise').val(nextFriday).attr('min', today);
        $bF.find('input.dpAbreise').val(nextSunday).attr('min', tomorrow);

        $bF.find('.magicHolder button:not(".addRoom")').click(function(e) {

            let validInput = true;

            if ($(this).closest('.magicHolder').hasClass('buchenbox_anAbreise')) {
                sumUpAnAbreise($bF, $(this));
            }

            if ($(this).closest('.magicHolder').hasClass('buchenbox_reiseTeilnehmer')) {
                validInput = sumUpReiseteilnehmer($bF.find('.buchenbox_reiseTeilnehmer'), $(this));
            }

            if ($(this).closest('.magicHolder').hasClass('show')) {
                $(this).attr('aria-expanded', false);
                if (validInput) {
                    $(this).closest('.magicHolder').removeClass('show');
                    $bF.find('.buchenbox_button button').prop('disabled', false);
                }
            } else {
                $bF.find('.magicHolder').removeClass('show');
                $(this).attr('aria-expanded', true);
                let topPos = $(this).height() + 55; // Height of Button + Padding - 3px um direkt darunter zu positionieren, aber leicht überlagert damit es seamless aussieht
                $(this).closest('.magicHolder').addClass('show').find('.magic').css('top', topPos + 'px');
                $bF.find('.buchenbox_button button').prop('disabled', true);
            }

        });


        $bF.find('input.dpAnreise').change(function() {
            if (new Date($(this).val()).getTime() > new Date($bF.find('input.dpAbreise').val()).getTime()) {
                $bF.find('input.dpAbreise').val(moment($(this).val()).add('days', 1).format('YYYY-MM-DD'));
            }
            $bF.find('input.dpAbreise').attr('min', moment($(this).val()).add('days', 1).format('YYYY-MM-DD'));
        });


        if (!hashObj.occupation) {
            addRoom($bF.find('.buchenbox_reiseTeilnehmer'));
        }

        $bF.find('button.addRoom').click(function(e) {
            addRoom($bF.find('.buchenbox_reiseTeilnehmer'));
        });

        generateStartEndDate($bF);
        generateOccupationString($bF);

        hashObj = setAndGetBuchenFilter(hashObj, $bF);

    }

};

const waAuslastung = function() {

    let lang = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguage');
    let sysLanguageUid = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguagesysuid');
    if (lang == "cz") {
        lang = "cs";
    }

    $.each($('.wa-auslastung'), function() {

        const $waAuslastungDiv = $(this);

        $.ajax({
            type: "POST",
            url: '/index.php?id=' + rootPage + '&type=1950&L=' + sysLanguageUid,
            data: {
                lang: lang,
                sysLanguageUid: sysLanguageUid,
                L: sysLanguageUid,
                auslastung: $waAuslastungDiv.data('auslastung'),
                sourceid: $waAuslastungDiv.data('sourceid'),
                tdType: $waAuslastungDiv.data('type'),
            },
            beforeSend: function() {
                $waAuslastungDiv.attr("aria-busy", true);
                $waAuslastungDiv.html('<span class="fas fa-circle-notch fa-spin"></span>');
            },
            success: function(result) {
                $waAuslastungDiv.html(result);
            },
            // error: function() {},
            complete: function() {
                $waAuslastungDiv.attr("aria-busy", false);
            }
        });

    });

};

var formatDateforDatepicker = function($date) {

    let d = ($date.getDate() < 10) ? '0' + $date.getDate() : $date.getDate();
    const mFix = $date.getMonth() + 1;
    let m = (mFix < 10) ? '0' + mFix : mFix;

    return $date.getFullYear() + '-' + m + '-' + d;
};

const copyToClipboard = function(obj, url) {
    function listener(e) {
        e.clipboardData.setData("text/plain", url);
        e.preventDefault();
    }
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);

    obj.after('<span id="copied" style="margin-left: 10px;">Kopiert!</span>');
    obj.mouseleave(function() {
        $('#copied').remove();
    });

};

// Braucht man um aus der Veranstaltungskachelansicht den Link auf "Ticket buchen" klicken zu können
const openVABookingLink = function(event, url) {
    event.preventDefault();
    window.open(url, '_blank');
};

const formatDateFromDatefield = function(date) {
    let d = new Date(date);
    let day = (d.getDate() < 10) ? '0' + d.getDate() : d.getDate();
    let month = ((d.getMonth() + 1) < 10) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
    return day + '.' + month + '.' + d.getFullYear();
}

const formatDateFromHash = function(date) {
    let d = date.split('.');
    d = d[2] + "-" + d[1] + "-" + d[0];
    return d;
}

const checkMerkzettel = function() {
    var merkZettelItems = $.cookie('merkZettelItems');

    if (merkZettelItems == null) {
        merkZettelItems = "";
    }

    var merkZettelArray = merkZettelItems.split(",");

    var tag = "*[data-typ][data-id]";
    $(tag).each(function() {
        if (merkZettelArray.length > 0) {
            for (var i = 0; i < merkZettelArray.length; i++) {
                if ($(this).data("typ") + "" + $(this).data("id") == (merkZettelArray[i])) {
                    if ($(this).hasClass('merken-liste')) {
                        $(this).parent().addClass("ttgBeitragMerkenActive");
                        $(this).removeClass('fa-regular').addClass('fa-solid');
                        $(this).siblings("span").children(".merken").html($(this).parent().attr("data-beitragGemerktText"));
                    }
                }
            }
        }
    });
}